// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__16nJP","actionsCol":"EnrolledClinics_actionsCol__15z6T"};